import '../App.scss';
import '../Css/ComponentStyles/SvgLine.css'
import { ReactComponent as Line } from '../assets/line.svg';

function SvgLine() {
    return (
        <Line className="line"/>
    )
}

export default SvgLine;